export const i18n = {
  defaultLocale: 'pt',
  locales: ['pt', 'en', 'es'],
  langDirection: {
    pt: 'ltr',
    en: 'ltr',
    es: 'ltr'
  }
} as const

export type Locale = (typeof i18n)['locales'][number]
